import React, { Component } from 'react';

import includes from 'lodash/includes';

import Tooltip from '@atlaskit/tooltip';

import { Label } from '@qality/common-components';
import { Select } from '@qality/common-components/src/atoms/Select';
import { ExecutionStatusService } from '@qality/common-service';
import {
  StatusSelectOption,
  StatusSelectOptionGroup,
  StatusUtils,
  Utils,
} from '@qality/common-utils';

import './_status-select.scss';

type OnChangeValue = [
  {
    name: 'statusesIds';
    value: Array<string>;
  }
];

type Props = {
  statuses: Array<string> | string;
  onChange: (value: OnChangeValue) => void;
  isDisabled?: boolean;
  tooltip?: string;
};

type State = {
  value: Array<StatusSelectOption> | StatusSelectOption;
  statuses: StatusSelectOptionGroup | Array<unknown>;
};

export const ALL_STATUSES: StatusSelectOption = {
  label: 'All statuses',
  value: '',
};

export default class StatusSelect extends Component<Props, State> {
  static defaultProps = {
    isDisabled: true,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      value: null,
      statuses: [],
    };
  }

  async componentDidMount(): Promise<void> {
    const statuses = await ExecutionStatusService.getStatuses();

    const statusOptions = statuses.allStatuses.map((status) => {
      return StatusUtils.mapStatusToOption(status);
    });

    const selectedStatuses = this.props.statuses
      ? statusOptions.filter((status) =>
          includes(this.props.statuses, status.value)
        )
      : ALL_STATUSES;

    this.setState({
      statuses: StatusUtils.groupStatusesByCategory(statuses.allStatuses),
      value: Utils.isNilOrEmpty(selectedStatuses)
        ? ALL_STATUSES
        : selectedStatuses,
    });
  }

  onChange = (options: Array<StatusSelectOption>): void => {
    const selectedOption = Utils.isNilOrEmpty(options)
      ? [ALL_STATUSES]
      : options.filter((option) => option.value != ALL_STATUSES.value);

    this.setState({
      value: selectedOption,
    });

    this.props.onChange([
      {
        name: 'statusesIds',
        value: selectedOption.map((option) => option.value),
      },
    ]);
  };

  render(): React.ReactNode {
    return (
      <div className='hide-focus-wrapper filter-common status-select-container'>
        <Label text='Status' />
        <Tooltip content={this.props.tooltip}>
          <div className='hide-focus-wrapper'>
            <Select
              isMulti
              isSearchable={false}
              id='qality-status-select'
              isClearable={true}
              options={this.state.statuses}
              value={this.state.value}
              onChange={this.onChange}
              isDisabled={this.props.isDisabled}
            />
          </div>
        </Tooltip>
      </div>
    );
  }
}
